import { InlineAlertComponent } from "@gx1/gx-ui-common";
import styles from "./error-banner.module.scss";

type ErrorBannerProps = { message?: string };
const ErrorBannerComponent = ({ message = "" }: ErrorBannerProps) => {
  return (
    <div className={styles.bannerContainer}>
      <InlineAlertComponent
        variant={"error"}
        message={message}
        showCloseButton={false}
      />
    </div>
  );
};

export default ErrorBannerComponent;
